import * as THREE from 'three'

class AutoInstancedMesh {
  private scene: THREE.Scene
  private groupedMeshes: Map<string, { geometry: THREE.BufferGeometry; material: THREE.Material; meshes: THREE.Mesh[] }>

  constructor(scene: THREE.Scene) {
    this.scene = scene
    this.groupedMeshes = new Map()
  }

  optimize() {
    this.groupMeshes()
    this.convertToInstancedMesh()
  }

  private groupMeshes() {
    this.groupedMeshes.clear()

    this.scene.traverse((object) => {
      if (object instanceof THREE.Mesh && !object.userData.isInstanced) {
        const key = this.getMeshKey(object)

        if (!this.groupedMeshes.has(key))
          this.groupedMeshes.set(key, { geometry: object.geometry, material: object.material, meshes: [] })

        this.groupedMeshes.get(key)!.meshes.push(object)
      }
    })
  }

  private convertToInstancedMesh() {
    this.groupedMeshes.forEach(({ geometry, material, meshes }) => {
      if (meshes.length < 2)
        return

      const instancedMesh = new THREE.InstancedMesh(geometry, material, meshes.length)
      instancedMesh.userData.isInstanced = true

      const matrix = new THREE.Matrix4()
      meshes.forEach((mesh, index) => {
        mesh.updateMatrix()
        instancedMesh.setMatrixAt(index, mesh.matrix)
        this.scene.remove(mesh)
      })

      instancedMesh.instanceMatrix.needsUpdate = true
      this.scene.add(instancedMesh)
    })
  }

  private getMeshKey(mesh: THREE.Mesh): string {
    // @ts-ignore
    return `${mesh.geometry.uuid}_${mesh.material.uuid}`
  }
}

export default AutoInstancedMesh
